import { render } from "./PredictingPage.vue?vue&type=template&id=72ddc9ec"
import script from "./PredictingPage.vue?vue&type=script&lang=js"
export * from "./PredictingPage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dominiksasko/Desktop/Projects/Piano-Chords-AI-Recognition/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__